module.exports = new __parcel__URL__("sharpice.904efdbe.png").toString();